export default __webpack_public_path__ + "static/getwaves-cover-ac8c651e2f1863b1e8df743f946fdf10.jpg";